import { Endpoints } from '@/api/ApiEndpoints';
import router from '@/router';
import { Inputs,validationSchema } from '@/entities/Leagues/LeaguesFormInputs'

const Leagues = {
	Plural: 'Leagues',
	Single: 'League',
	Inputs: Inputs,	
	Relationships: [
		{
			name: 'country',
			endpoint: Endpoints.COUNTRIES_FOR_FILTERS,
			mapping: (response) => {
				return response;
			}
		},
		{
			name: 'countryIds',
			endpoint: Endpoints.COUNTRIES_FOR_FILTERS,
			mapping: (response) => {
				return response;
			},
		},
	],
	ValidationSchema: validationSchema,
	SaveCallBack: (id) =>{ 
		//router.push(`/leagues/edit/${id}`)
	}
};

export default Leagues;
